import { updateSettings } from "../repository/settings.repo";

export const UpdateSettings = async (data) => {
  try {
    const resp = await updateSettings(data);
    return resp.data;
  } catch (error) {
    return error.response.data;
  }
};
